export const placementStats = [
    { year: '2020', offers: 150, highest: '12 LPA', average: '4.2 LPA' },
    { year: '2021', offers: 185, highest: '15 LPA', average: '4.8 LPA' },
    { year: '2022', offers: 210, highest: '18 LPA', average: '5.5 LPA' },
    { year: '2023', offers: 245, highest: '24 LPA', average: '6.2 LPA' },
    { year: '2024', offers: 280, highest: '32 LPA', average: '7.5 LPA' },
];

export const topRecruiters = [
    { name: 'TCS', logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Tata_Consultancy_Services_Logo.svg' },
    { name: 'Infosys', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg' },
    { name: 'Wipro', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Wipro_Primary_Logo_Color_RGB.svg' },
    { name: 'Cognizant', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/43/Cognizant_logo_2022.svg' },
    { name: 'Accenture', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Accenture.svg' },
    { name: 'IBM', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg' },
    { name: 'Oracle', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg' },
    { name: 'Amazon', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
    { name: 'Google', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg' },
    { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg' },
    { name: 'Meta', logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg' },
    { name: 'Adobe', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d3/Adobe_Corporate_logo.svg' },
    { name: 'Intel', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Intel-logo.svg' },
    { name: 'Cisco', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Cisco_logo_blue_2016.svg' },
    { name: 'Dell', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/18/Dell_logo_2016.svg' },
    { name: 'HP', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/HP_logo_2012.svg' },
    { name: 'Siemens', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5f/Siemens-logo.svg' },
    { name: 'Samsung', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg' },
    { name: 'SAP', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg' },
    { name: 'Nvidia', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Nvidia_logo.svg' },
    { name: 'Qualcomm', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a8/Qualcomm_logo.svg' },
    { name: 'Capgemini', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Capgemini_2017_logo.svg' },
    { name: 'HCL', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/HCL_Technologies_logo.svg' },
    { name: 'Mindtree', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/30/Mindtree_logo.svg' },
    { name: 'LTI', logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Larsen_%26_Toubro_Infotech_Logo.svg' },
    { name: 'Tech Mahindra', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Tech_Mahindra_New_Logo.svg' },
    { name: 'Deloitte', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2b/Deloitte.svg' },
    { name: 'EY', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/34/EY_logo_2019.svg' },
    { name: 'KPMG', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/de/KPMG_logo.svg' },
    { name: 'PwC', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/PricewaterhouseCoopers_Logo.svg' },
    { name: 'Uber', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/58/Uber_logo_2018.svg' },
    { name: 'Zomato', logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bd/Zomato_Logo.svg' },
    { name: 'Swiggy', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/13/Swiggy_logo.svg' },
    { name: 'Flipkart', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/18/Flipkart_logo.svg' },
    { name: 'Paytm', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Paytm_Logo_%28standalone%29.svg' },
    { name: 'BYJU\'S', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5a/BYJU%27S_logo.svg' },
    { name: 'Zoho', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Zoho_logo.svg' },
    { name: 'Freshworks', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Freshworks_logo.svg' },
    { name: 'Razorpay', logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e2/Razorpay_logo.svg' },
    { name: 'Cred', logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Cred_logo.svg' },
    { name: 'PolicyBazaar', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/15/PolicyBazaar_Logo.svg' },
    { name: 'InMobi', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/aa/InMobi_Logo.svg' },
    { name: 'Ola', logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/Ola_Logo.svg' },
    { name: 'Airtel', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/Airtel_logo_2011.svg' },
    { name: 'Jio', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Reliance_Jio_Logo.svg' },
    { name: 'Bosch', logo: 'https://upload.wikimedia.org/wikipedia/commons/1/16/Bosch-logo.svg' },
    { name: 'TATA Elxsi', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a2/Tata_Elxsi_logo.svg' },
    { name: 'Honeywell', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/aa/Honeywell_logo.svg' },
    { name: 'ABB', logo: 'https://upload.wikimedia.org/wikipedia/commons/0/00/ABB_logo.svg' },
    { name: 'Schneider Electric', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/95/Schneider_Electric_logo.svg' },
];

export const placementTraining = [
    {
        title: "Aptitude Training",
        description: "Rigorous training on quantitative, logical, and verbal reasoning to crack initial screening rounds."
    },
    {
        title: "Technical Workshops",
        description: "Hands-on sessions on coding, system design, and domain-specific technologies."
    },
    {
        title: "Mock Interviews",
        description: "One-on-one sessions with industry experts to build confidence and refine communication."
    },
    {
        title: "Soft Skills",
        description: "Enhancing personality, teamwork, and leadership qualities essential for corporate life."
    }
];

export const companyPlacementData = {
    '2025': [
        { name: 'TCS', offers: 92, color: '#0C2B4E' },
        { name: 'Infosys', offers: 70, color: '#1D546C' },
        { name: 'Wipro', offers: 52, color: '#2A789A' },
        { name: 'Cognizant', offers: 44, color: '#3B82F6' },
        { name: 'Accenture', offers: 30, color: '#8B5CF6' },
        { name: 'Capgemini', offers: 28, color: '#6366F1' },
        { name: 'HCL', offers: 22, color: '#EC4899' },
        { name: 'Amazon', offers: 12, color: '#F97316' },
        { name: 'Microsoft', offers: 5, color: '#00A4EF' },
        { name: 'Google', offers: 3, color: '#EA4335' },
        { name: 'Others', offers: 140, color: '#94A3B8' },
    ],
    '2024': [
        { name: 'TCS', offers: 85, color: '#0C2B4E' },
        { name: 'Infosys', offers: 62, color: '#1D546C' },
        { name: 'Wipro', offers: 45, color: '#2A789A' },
        { name: 'Cognizant', offers: 38, color: '#3B82F6' },
        { name: 'Accenture', offers: 25, color: '#8B5CF6' },
        { name: 'Capgemini', offers: 22, color: '#6366F1' },
        { name: 'HCL', offers: 18, color: '#EC4899' },
        { name: 'Mindtree', offers: 15, color: '#F59E0B' },
        { name: 'Deloitte', offers: 12, color: '#10B981' },
        { name: 'Amazon', offers: 10, color: '#F97316' },
        { name: 'Others', offers: 120, color: '#94A3B8' },
    ],
    '2023': [
        { name: 'TCS', offers: 78, color: '#0C2B4E' },
        { name: 'Infosys', offers: 55, color: '#1D546C' },
        { name: 'Wipro', offers: 40, color: '#2A789A' },
        { name: 'Cognizant', offers: 35, color: '#3B82F6' },
        { name: 'Accenture', offers: 20, color: '#8B5CF6' },
        { name: 'Capgemini', offers: 18, color: '#6366F1' },
        { name: 'HCL', offers: 15, color: '#EC4899' },
        { name: 'Mindtree', offers: 12, color: '#F59E0B' },
        { name: 'Deloitte', offers: 10, color: '#10B981' },
        { name: 'Amazon', offers: 8, color: '#F97316' },
        { name: 'Others', offers: 100, color: '#94A3B8' },
    ],
    '2022': [
        { name: 'TCS', offers: 65, color: '#0C2B4E' },
        { name: 'Infosys', offers: 48, color: '#1D546C' },
        { name: 'Wipro', offers: 35, color: '#2A789A' },
        { name: 'Cognizant', offers: 30, color: '#3B82F6' },
        { name: 'Accenture', offers: 15, color: '#8B5CF6' },
        { name: 'Others', offers: 80, color: '#94A3B8' },
    ]
};
